import { Moment } from 'moment'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import { blockCategoryAdaptorSelector } from '../../../App/store/features/blockCategory/blockedCategorySlice'
import { Person } from '../../../App/store/features/person/IPerson'
import { Button } from '../../../Common/Button'
import { store } from '../../../store'
import { createBlock } from '../../store/thunks/createBlock'
import { getBlock } from '../../store/thunks/fetchBlock'
import { isInstanceOfIThunkError } from '../../utils/interfaceCheck'
import { RequiredMessages } from '../RequiredMessages'

import { BlockFormFields } from './BlockFormFields'
import { IBlockFormSubmit } from './types/IBlockFormSubmit'

interface IProps {
  persons: Person[]
  selectedPersonUuid: string
  appointmentMoment: Moment
}

export const BlockForm = ({
  persons,
  appointmentMoment,
  selectedPersonUuid,
}: IProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { setValue, watch, handleSubmit, register, formState } =
    useForm<IBlockFormSubmit>({
      mode: 'onSubmit',
      defaultValues: {
        blockedCategoryUuid: '',
        personUuid: selectedPersonUuid,
        isRepeat: false,
        repeatWeekInterval: 6,
        repeatStopsAt: appointmentMoment.clone().add(10, 'weeks'),
        repeatOption: 'stopAfter',
        notes: '',
        startsAt: appointmentMoment,
        startHour: appointmentMoment.clone().format('HH:mm'),
        endHour: appointmentMoment.clone().add(60, 'm').format('HH:mm'),
      },
    })

  useEffect(() => {
    register('blockedCategoryUuid', { required: 'Please select a category.' })
  }, [register])

  // @ts-ignore
  const watchIsRepeat = watch('isRepeat', false)
  // @ts-ignore
  const watchRepeatOption = watch('repeatOption', 'Stop after')

  const onSubmit = (formObject: any) => {
    dispatch(createBlock(formObject)).then(({ payload }) => {
      if (typeof payload !== 'undefined' && !isInstanceOfIThunkError(payload)) {
        dispatch(getBlock({ uuid: payload.uuid, type: 'create' }))
      }
      return null
    })
  }

  const allBlockCategories = blockCategoryAdaptorSelector.selectAll(
    store.getState(),
  )

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <BlockFormFields
        blockCategories={allBlockCategories}
        persons={persons}
        appointmentMoment={appointmentMoment}
        setValue={setValue}
        watchIsRepeat={watchIsRepeat}
        watchRepeatOption={watchRepeatOption}
      />
      <RequiredMessages errors={formState.errors} />

      <Button type="submit">{t('Save')}</Button>
    </form>
  )
}
